import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actions from './actions';
import selectAllProps from './selectors';
import {Paper} from 'material-ui';
import _ from 'lodash';
import {
    Table,
    TableBody,
    TableHeader,
    TableHeaderColumn,
    TableRow,
    TableRowColumn,
} from 'material-ui/Table';

import MyLoader from '../../components/MyLoader';

class ProjectStatsContainer extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {};
    }

    componentWillMount() {
        if (this.props.stats == null) this.props.actions.loadProjectStats(this.props.project.id);
    }

    render() {
        if (this.props.loading || !this.props.stats) return (<MyLoader/>);
        const paperStyle = {display: 'inline-block', width: '25%', padding: 15, margin: 10, textAlign: 'center'};
        const numberStyle = {fontSize: 48, fontWeight: 'normal'};
        const labelStyle = {fontSize: 24, fontWeight: 'bold'};
        const typesArray = _.toArray(this.props.stats.types);
        const typesRows = typesArray.map((type, index) => (
            <TableRow key={index}>
                <TableRowColumn>{type.name}</TableRowColumn>
                <TableRowColumn>{type.total_days}</TableRowColumn>
                <TableRowColumn>{type.total_hours}</TableRowColumn>
            </TableRow>
        ));
        const usersArray = _.toArray(this.props.stats.users);
        const usersRows = usersArray.map((user, index) => (
            <TableRow key={index}>
                <TableRowColumn>{user.name}</TableRowColumn>
                <TableRowColumn>{user.total_days}</TableRowColumn>
                <TableRowColumn>{user.total_hours}</TableRowColumn>
            </TableRow>
        ));
        return (
            <div style={{marginTop: 20}}>
                <Paper style={paperStyle}>
                    <span style={numberStyle}>{this.props.stats.total_days}</span>
                    <span style={labelStyle}>&nbsp;jours</span>
                </Paper>
                <Paper style={paperStyle}>
                    <span style={numberStyle}>{this.props.stats.total_hours}</span>
                    <span style={labelStyle}>&nbsp;heures</span>
                </Paper>
                <h2>Détail par type de tache</h2>
                <Table selectable={false} multiSelectable={false}>
                    <TableHeader>
                        <TableRow>
                            <TableHeaderColumn>Type</TableHeaderColumn>
                            <TableHeaderColumn>Nombre de jours</TableHeaderColumn>
                            <TableHeaderColumn>Nombre d'heures</TableHeaderColumn>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {typesRows}
                    </TableBody>
                </Table>
                <h2>Détail par intervenant</h2>
                <Table selectable={false} multiSelectable={false}>
                    <TableHeader>
                        <TableRow>
                            <TableHeaderColumn>Intervenant</TableHeaderColumn>
                            <TableHeaderColumn>Nombre de jours</TableHeaderColumn>
                            <TableHeaderColumn>Nombre d'heures</TableHeaderColumn>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {usersRows}
                    </TableBody>
                </Table>
            </div>
        );
    }
}

ProjectStatsContainer.propTypes = {
    loading: PropTypes.bool,
    actions: PropTypes.object,
    params: PropTypes.object,
    project: PropTypes.object,
    stats: PropTypes.object
};

ProjectStatsContainer.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    return selectAllProps(state);
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ProjectStatsContainer);


/** WEBPACK FOOTER **
 ** ./src/container/ProjectContainer/ProjectStatsContainer.js
 **/